<template>
    <div class="l-form-row">
        <slot></slot>
    </div>
</template>
<script>
export default {
  name: "cFormRow",
  props: {},
  data() {
    return {};
  },
  methods: {},
  mounted() {}
};
</script>
<style lang="scss">
@import "~@/assets/scss/variable";
.l-form-row {
  box-sizing: border-box;
  margin: 0 10px;
  text-align: left;
}
</style>
